// extracted by mini-css-extract-plugin
module.exports = {"main-ourMissions":"style_main-ourMissions__2yn1h"};